import { CustomComponentProps } from "utils/types/general.types";
import "assets/css/svg.css";

export type SVGSizes =
    | 12
    | 14
    | 16
    | 18
    | 20
    | 22
    | 24
    | 26
    | 28
    | 30
    | 36
    | 40;

export type SVGProps = CustomComponentProps & {
    svg: string;
    size?: SVGSizes;
};

const SVG = ({ svg, size = 16, className, style }: SVGProps) => {
    return (
        <div
            className={`svg-${size} momeento-svg ${svg}-svg ${className}`}
            style={style}
        ></div>
    );
};

export default SVG;
